var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckZones(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70725 0.29325C10.0983 0.68425 10.0983 1.31631 9.70725 1.70731L4.70725 7.70731C4.51225 7.90231 4.25625 8.00028 4.00025 8.00028C3.74425 8.00028 3.48825 7.90231 3.29325 7.70731L0.29325 4.70731C-0.0977499 4.31631 -0.0977499 3.68425 0.29325 3.29325C0.68425 2.90225 1.31625 2.90225 1.70725 3.29325L4.00025 5.58634L8.29325 0.29325C8.68425 -0.0977499 9.31625 -0.0977499 9.70725 0.29325Z",
    fill: "#32C1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckZones);
export default __webpack_public_path__ + "static/media/checkZones.9c89fd0d52658fc8a8f872b193dc80b5.svg";
export { ForwardRef as ReactComponent };